import Vue from 'vue'
import Router from 'vue-router'
import Home from './containers/PC/Index'
import Product from './containers/PC/Product'
import Details from './containers/PC/Details'
import List from './containers/PC/List'
import Checkout from './containers/PC/Checkout'
import Done from './containers/PC/Done'
import wechatScheme from './containers/PC/Scheme'

import mobileHome from './containers/Mobile/Index'
import mobileProduct from './containers/Mobile/Product'
import mobiletProduct from './containers/Mobile/tProduct'
import mobileCheckout from './containers/Mobile/Checkout'
import mobiletCheckout from './containers/Mobile/tCheckout'
import mobileList from './containers/Mobile/List'
import mobileCategory from './containers/Mobile/Category'
import mobileOldProduct from './containers/Mobile/OldProduct'
import mobileOldProductSearch from './containers/Mobile/oldproductSearch'
import mobileProductSearch from './containers/Mobile/productSearch'
import mobileDone from './containers/Mobile/Done'
import payOrder from './containers/Mobile/Pay'
import mobileWechatAuthor from './containers/Mobile/Wechat/author'
import Test from './containers/Mobile/Test'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '以旧换新首页'
      },
    },
    {
      path: '/product/:id',
      name: 'Product',
      component: Product,
      meta: {
        title: '产品详情'
      },
    }, {
      path: '/list',
      name: 'list',
      component: List,
      meta: {
        title: '产品列表'
      },
    },
    {
      path: '/details/:id',
      name: 'Details',
      component: Details,
      meta: {
        title: '产品详情'
      },
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
      meta: {
        title: '提交订单'
      },
    },
    {
      path: '/done',
      name: 'Done',
      component: Done,
      meta: {
        title: '提交成功'
      },
    },{
      path: '/wechat/scheme',
      name: 'wechatScheme',
      component: wechatScheme,
      meta: {
        title: '扫码支付'
      },
    },
    // {
    //   path: '/mobile',
    //   name: 'mobilehome',
    //   component: mobileHome,
    //   meta: {
    //     title: '以旧换新首页'
    //   },
    // },
    // {
    //   path: '/mobile/list',
    //   name: 'mobilelist',
    //   component: mobileList,
    //   meta: {
    //     title: '产品列表'
    //   },
    // }, {
    //   path: '/mobile/product/search',
    //   name: 'mobileProductSearch',
    //   component: mobileProductSearch,
    //   meta: {
    //     title: '搜索'
    //   },
    // },
    // {
    //   path: '/mobile/product/:id',
    //   name: 'mobileproduct',
    //   component: mobileProduct,
    //   meta: {
    //     title: '产品详情'
    //   },
    // },
    // {
    //   path: '/mobile/ttt/:id',
    //   name: 'mobiletproduct',
    //   component: mobiletProduct,
    //   meta: {
    //     title: '产品详情'
    //   },
    // },
    // {
    //   path: '/mobile/checkout',
    //   name: 'mobileCheckout',
    //   component: mobileCheckout,
    //   meta: {
    //     title: '提交订单'
    //   },
    // },{
    //   path: '/mobile/tcheckout',
    //   name: 'mobiletCheckout',
    //   component: mobiletCheckout,
    //   meta: {
    //     title: '在线支付'
    //   },
    // }, {
    //   path: '/mobile/category',
    //   name: 'mobileCategory',
    //   component: mobileCategory,
    //   meta: {
    //     title: '选择机型'
    //   },
    // }, {
    //   path: '/mobile/oldproduct/search',
    //   name: 'mobileOldProductSearch',
    //   component: mobileOldProductSearch,
    //   meta: {
    //     title: '机型搜索'
    //   },
    // },{
    //   path: '/mobile/oldproduct/:id',
    //   name: 'mobileOldProductId',
    //   component: mobileOldProduct,
    //   meta: {
    //     title: '评估机型'
    //   },
    // }, {
    //   path: '/test',
    //   name: 'test',
    //   component: Test,
    //   meta: {
    //     title: '提交订单'
    //   },
    // },{
    //   path: '/mobile/wechat/author',
    //   name: 'mobileWechatAuthor',
    //   component: mobileWechatAuthor,
    //   meta: {
    //     title: '微信授权'
    //   },
    // }, 
    {
      path: '/pay/:order',
      name: 'payOrder',
      component: payOrder,
      meta: {
        title: '在线付款'
      },
    }, {
      path: '/mobile/done',
      name: 'done',
      component: mobileDone,
      meta: {
        title: '提交成功'
      },
    },
  ]
})
